import { Root as e } from "./elements/Attribution/Root/index.js";
import { t as o } from "./types-Vau8BGkK.js";
const p = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Root: e,
  Types: o
}, Symbol.toStringTag, { value: "Module" }));
export {
  p as i
};
